import classNames from "classnames";
import { IconProps } from "../types";
import { asIcon } from "../utils/library";

const Feedback = ({
    className,
    width = "1.5rem",
    height = "1.5rem",
}: IconProps) => {
    const classes = classNames("feedbackIcon", className);

    return (
        <svg
            className={classes}
            width={width}
            height={height}
            viewBox="2 2 20 20"
        >
            <g fillRule="evenodd">
                <path
                    d="m20 2h-16c-1.1 0-1.99 0.9-1.99 2l-0.01 18 4-4h14c1.1 0 2-0.9 2-2v-12c0-1.1-0.9-2-2-2zm-7 12h-2v-2h2v2zm0-4h-2v-4h2v4z"
                    fillRule="nonzero"
                />
            </g>
        </svg>
    );
};

const IconFeedback = asIcon(Feedback);
export default IconFeedback;
